import React from 'react'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Icon } from '@ui'

export default function HiddenLocationIndicator({
  floor,
  isVisible,
}: {
  floor?: boolean
  isVisible?: boolean
}) {
  return (
    <Tooltip2
      disabled={isVisible}
      content={`This ${floor ? 'floor' : 'building'} is hidden for viewers and IT`}
    >
      <Icon name={isVisible ? 'eye' : 'eye-slash'} style={{ fontSize: 12 }} />
    </Tooltip2>
  )
}
